export const trackViewedProductKlaviyo = (product) => {
    const variant = product?.content?.shopify?.variants[0]?.content?.shopify;
    let _learnq = window._learnq || [];
    const item = {
      ProductName: variant?.title,
      ProductID: variant?.variantId?.replace("productVariantShopify-", ""),
      SKU: variant?.sku,
      Categories: null,
      URL: `${process.env.GATSBY_URL}/products/${product?.main?.slug?.current}`,
      Brand: "Groove",
      Price: parseFloat(variant?.price),
    };
    _learnq.push(["track", "Viewed Product", item]);
  };